// @module Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Validation
define('Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Validation.View'
,	[
	'tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_validation.tpl'
	
    ,	'Backbone'
    ,   'underscore'
    ]
, function (
	tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_validation_tpl
	
	,	Backbone
	,	_
)
{
    'use strict';

	// @class Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Validation.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_validation_tpl

		// @method initialize
		// @param {GlobalViews.Message.View.InitializeOptions} options
		// @return {Void}

	,	event: {
			'click [data-action="close-message"]': 'closeMessage'
		}

	,	show: function show ($placeholder, time)
		{
			$placeholder.empty();

			this.render();
			$placeholder.html(this.$el).show();

			if (time && time > 0)
			{
				setTimeout(function ()
				{
					$placeholder.fadeOut(function ()
					{
						$placeholder.empty();
					});
				}, time);
			}
		}

	,	closeMessage: function closeMessage (e)
		{
			return _.isFunction(this.options.closeMessageHandler) && this.options.closeMessageHandler(e);
		}

	,	childViews:  {
			'global-views-message-childview-message': function ()
			{
				return this.options.childView;
			}
		}

		// @method getContext
		// @return {GlobalViews.Message.View.Context}
	,	getContext: function getContext ()
		{
			var has_error_code = !!this.options.message.errorCode
			,	message = has_error_code ? this.options.message.message : this.options.message
			,	errorCode = this.options.message.errorCode;

			return {
					// @property {String} message
					message: message
					// @property {Boolean} hasErrorCode
				,	hasErrorCode: has_error_code
					// @property {String} errorCode
				,	errorCode: errorCode
					// @property {Boolean} closable
				,	closable: !!this.options.closable
					// @property {String} type
				,	type: this.options.type ? 'global-views-message-' + this.options.type : ''
					// @property {Boolean} showMultipleMessage
				,	showMultipleMessage: !!_.isObject(this.options.message) && !has_error_code
					// @property {Array} messages
				,	messages: _.isArray(this.options.message) ? this.options.message : [this.options.message]
					// @property {Boolean} showStringMessage
				,	showStringMessage: !this.options.childView
			};
			// @class GlobalViewss.Message.View
		}
	});
});
